(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/loader/loader.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/loader/loader.js');
"use strict";


const {
  useEffect
} = React;
const Loader = _ref => {
  let {
    elementRef
  } = _ref;
  useEffect(() => {
    const loader = new svs.ui.Loader(elementRef.current);
    loader.show(300);
    return () => loader.hide(true);
  });
  return React.createElement("div", null);
};
svs.ticket_partner.sharedComponents.loader.Loader = Loader;

 })(window);